function quickViewFn() {
    document.querySelectorAll(".custom-quickview-main").forEach((quickview) => {
    let optionPopups = quickview.querySelectorAll(".cqv-option-popup");
    let optionPopupsClose = quickview.querySelectorAll(".cqv-option-popup-close");
    let options = quickview.querySelectorAll(".cqv-option");
    let optionSelects = quickview.querySelectorAll(".cqv-option-select");
    let variantSelect = quickview.querySelector(".cqv-variant-select");
    let addToCartText = quickview.querySelector(".add_to_carttext");
    let soldOutText = quickview.querySelector(".sold-out-message");
    let quickAddButton = quickview.querySelector(".quick-add__submit");
    let optionsListItems = quickview.querySelectorAll(".cqv-options-list li");
    let quickViewOpner = quickview.querySelector(".custom-quickview-opner");
    let quickViewClose = quickview.querySelector(".cqv-header-close");
  
    quickViewOpner.addEventListener("click", () => {
      quickview.querySelector(".custom-quickview-inner").classList.add('active');
    });
    quickViewClose.addEventListener("click", () => {
      quickview.querySelector(".custom-quickview-inner").classList.remove('active');
    });
    
    variantSelect.addEventListener("change", (event) => {
  let selectedOption = event.target.querySelector('option:checked');
  let isAvailable = selectedOption && selectedOption.classList.contains('available');
  // console.log(isAvailable, event.target.classList);

  if (isAvailable) {
    addToCartText.classList.remove('hidden');
    soldOutText.classList.add('hidden');
    quickAddButton.disabled = false;
  } else {
    addToCartText.classList.add('hidden');
    soldOutText.classList.remove('hidden');
    quickAddButton.disabled = true;
  }
});


    // Handle option click to display corresponding popup
    options.forEach((option) => {
      option.addEventListener("click", (event) => {
        let selectElement = option.querySelector(".cqv-option-select");
        let popupId = selectElement ? selectElement.dataset.option : null;
        optionPopups.forEach((popup) => popup.classList.remove("active"));
        if (popupId) {
          quickview.querySelector(`#${popupId}`).classList.add("active");
        }
      });
    });

    // Handle option list item click to select a corresponding option
    optionsListItems.forEach((item) => {
      item.addEventListener("click", (event) => {
        let selectedValue = event.target.dataset.opvalue;
        let optionToSelect = quickview.querySelector(`option[data-opvalue="${selectedValue}"]`);
        if (optionToSelect) {
          optionToSelect.selected = true;
          let changeEvent = new Event("change");
          optionToSelect.closest('select').dispatchEvent(changeEvent);
          optionPopups.forEach((popup) => popup.classList.remove("active"));
        }
      });
    });

    // Handle option select change and update the variant select
    optionSelects.forEach((select) => {
      select.addEventListener("change", (event) => {
        let combinedValue = "";
        optionSelects.forEach((selectElement) => {
          combinedValue += selectElement.value;
        });
        let variantOption = variantSelect.querySelector(`option[data-variant="${combinedValue}"]`);
        if (variantOption) {
          variantOption.selected = true;
          let changeEvent = new Event("change");
          variantSelect.dispatchEvent(changeEvent);
        }
      });
    });

    // Close popups when the close button is clicked
    optionPopupsClose.forEach((closeButton) => {
      closeButton.addEventListener("click", () => {
        optionPopups.forEach((popup) => popup.classList.remove("active"));
      });
    });

    // Close popups when clicking outside of the quickview
    document.addEventListener("click", (event) => {
      let isClickInsideQuickview = quickview.contains(event.target);
      if (!isClickInsideQuickview) {
        optionPopups.forEach((popup) => popup.classList.remove("active"));
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  quickViewFn();
});

window.addEventListener('quickViewReInit', () => {
  quickViewFn();
});

window.addEventListener('productRecommLoaded', () => {
  let gridSlider = document.querySelector('.related-grid');
  if (gridSlider) {
    new Flickity(gridSlider, {
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false
    });
  }
  quickViewFn();
});
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 750) {
    document.querySelectorAll('.footer-block--menu').forEach(function (block) {
      const heading = block.querySelector('h2');

      if (heading) {
        heading.addEventListener('click', function () {
          block.classList.toggle('active');
        });
      }
    });
  }
});
